// extracted by mini-css-extract-plugin
export default {"iconWrap":"Breadcrumbs-module__iconWrap__uyHtF","container":"Breadcrumbs-module__container__UtLlv"};